import { useAuth0 } from '@auth0/auth0-react';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { updateChat } from '../apis/chatApi';
import { UpdateChatRequest } from '../apis/types';

export const useStarChat = () => {
  const { getAccessTokenSilently } = useAuth0();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async ({ chatId, starred }: { chatId: string; starred: boolean }) => {
      const token = await getAccessTokenSilently();
      const updateData: UpdateChatRequest = { starred };
      return updateChat(chatId, updateData, token);
    },
    onSuccess: () => {
      // Invalidate and refetch chats list
      queryClient.invalidateQueries({ queryKey: ['chats'] });
    },
    onError: (error) => {
      console.error('Error starring/unstarring chat:', error);
    },
  });

  return {
    starChat: mutation.mutateAsync,
    isStarring: mutation.isPending,
    error: mutation.error,
  };
};